
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-TerraNova-charcoal text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-4 text-TerraNova-cream">TerraNova Limited</h3>
          <p className="text-TerraNova-sand mb-6">Grounded in Expertise. Built on Trust</p>
          <div className="flex justify-center space-x-6">
            <Link to="/contact" className="text-TerraNova-sand hover:text-TerraNova-cream transition duration-300">Contact Us</Link>
          </div>
          <div className="mt-6 pt-6 border-t border-TerraNova-slate">
            <p className="text-TerraNova-sand">&copy; 2025 TerraNova Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
